(() => {
  const ELEMENT_NAME = 'art-tagged-code-offers';

  if (customElements.get(ELEMENT_NAME)) return;

  class ArtTaggedCodeOffers extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;

      this.root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      this.sectionId =
        this.dataset.sectionId || '';

      this.productFormId =
        this.dataset.productFormId || '';

      this.quantityInputId =
        this.dataset.quantityInputId || '';

      this.currency =
        this.dataset.currency || 'INR';

      this.cards = Array.from(
        this.querySelectorAll('[data-ofy-card]')
      );

      this.track =
        this.querySelector('[data-ofy-track]');

      this.counter =
        this.querySelector('[data-ofy-counter]');

      this.prevButton =
        this.querySelector('[data-ofy-prev]');

      this.nextButton =
        this.querySelector('[data-ofy-next]');

      this.dots = Array.from(
        this.querySelectorAll('[data-ofy-dot]')
      );

      this.status =
        this.querySelector('[data-ofy-status]');

      this.variants =
        this.readVariants();

      this.form =
        document.getElementById(this.productFormId) ||
        document.querySelector(
          'form[data-type="add-to-cart-form"]'
        );

      this.quantityInput =
        document.getElementById(this.quantityInputId) ||
        (
          this.form
            ? this.form.querySelector(
                'input[name="quantity"]'
              )
            : null
        );

      this.variantInput =
        this.form
          ? this.form.querySelector(
              '.product-variant-id, input[name="id"]'
            )
          : null;

      this.currentIndex = 0;

      this.onClick =
        this.handleClick.bind(this);

      this.onScroll =
        this.handleScroll.bind(this);

      this.onQuantityChange =
        this.handleQuantityChange.bind(this);

      this.onVariantChange =
        this.handleVariantChange.bind(this);

      this.addEventListener(
        'click',
        this.onClick
      );

      if (this.track) {
        this.track.addEventListener(
          'scroll',
          this.onScroll,
          { passive: true }
        );
      }

      if (this.quantityInput) {
        this.quantityInput.addEventListener(
          'input',
          this.onQuantityChange
        );

        this.quantityInput.addEventListener(
          'change',
          this.onQuantityChange
        );
      }

      if (this.form) {
        this.form.addEventListener(
          'change',
          this.onVariantChange
        );
      }

      this.refresh();
      this.updateNavigation(0);
    }


    readVariants() {
      const node =
        this.querySelector('[data-ofy-variants]');

      if (!node) return [];

      try {
        return JSON.parse(
          node.textContent || '[]'
        );
      } catch (_) {
        return [];
      }
    }


    getCurrentVariant() {
      const id =
        this.variantInput &&
        this.variantInput.value
          ? String(this.variantInput.value)
          : '';

      return (
        this.variants.find(
          (variant) =>
            String(variant.id) === id
        ) ||
        this.variants[0] ||
        null
      );
    }


    getCurrentQuantity() {
      if (!this.quantityInput) return 1;

      const value =
        Number.parseInt(
          this.quantityInput.value,
          10
        );

      return (
        Number.isFinite(value) &&
        value > 0
      )
        ? value
        : 1;
    }


    getUnitPrice() {
      const variant =
        this.getCurrentVariant();

      return (
        variant &&
        Number.isFinite(Number(variant.price))
      )
        ? Number(variant.price)
        : 0;
    }


    async getCart() {
      const response = await fetch(
        this.root + 'cart.js',
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to read Shopify cart.'
        );
      }

      return response.json();
    }


    getCartSubtotal(cart) {
      const subtotal =
        Number(
          cart &&
          cart.items_subtotal_price
        );

      if (Number.isFinite(subtotal)) {
        return subtotal;
      }

      const originalTotal =
        Number(
          cart &&
          cart.original_total_price
        );

      return Number.isFinite(originalTotal)
        ? originalTotal
        : 0;
    }


    formatMoney(cents) {
      const value =
        Number(cents) / 100;

      try {
        return new Intl.NumberFormat(
          'en-IN',
          {
            style: 'currency',
            currency: this.currency,
            maximumFractionDigits: 0
          }
        ).format(value);
      } catch (_) {
        return '₹' + Math.round(value);
      }
    }


    async refresh() {
      try {
        const cart =
          await this.getCart();

        const actualSubtotal =
          this.getCartSubtotal(cart);

        const quantity =
          this.getCurrentQuantity();

        const unitPrice =
          this.getUnitPrice();

        const projectedSubtotal =
          actualSubtotal +
          unitPrice * quantity;

        this.cards.forEach(
          (card, index) => {
            this.updateCard(
              card,
              index,
              actualSubtotal,
              projectedSubtotal,
              unitPrice,
              quantity
            );
          }
        );

      } catch (_) {

        const quantity =
          this.getCurrentQuantity();

        const unitPrice =
          this.getUnitPrice();

        const projectedSubtotal =
          unitPrice * quantity;

        this.cards.forEach(
          (card, index) => {
            this.updateCard(
              card,
              index,
              0,
              projectedSubtotal,
              unitPrice,
              quantity
            );
          }
        );
      }
    }


    updateCard(
      card,
      index,
      actualSubtotal,
      projectedSubtotal,
      unitPrice,
      quantity
    ) {
      const minimum =
        Number(
          card.dataset.minimumSubtotal
        ) || 0;

      const ribbon =
        card.querySelector(
          '[data-ofy-ribbon]'
        );

      const stateIcon =
        card.querySelector(
          '[data-ofy-state-icon]'
        );

      const progressText =
        card.querySelector(
          '[data-ofy-progress]'
        );

      const progressFill =
        card.querySelector(
          '[data-ofy-progress-fill]'
        );

      const progressMeta =
        card.querySelector(
          '[data-ofy-progress-meta]'
        );

      const helper =
        card.querySelector(
          '[data-ofy-helper]'
        );

      const button =
        card.querySelector(
          '[data-ofy-action]'
        );

      const eligible =
        projectedSubtotal >= minimum;

      card.classList.toggle(
        'is-unlocked',
        eligible
      );

      card.classList.toggle(
        'is-locked',
        !eligible
      );

      if (eligible) {
        if (index === 0) {
          ribbon.textContent =
            'UNLOCKED FOR YOU';
        } else {
          ribbon.textContent =
            'OFFER UNLOCKED';
        }

        stateIcon.textContent = '✓';

        if (helper) {
          helper.textContent =
            index === 0
              ? 'Apply at checkout'
              : 'This offer is unlocked for your selected quantity.';
        }

        button.textContent =
          'Copy Code';

        button.dataset.mode =
          'copy';

        return;
      }


      stateIcon.textContent = '🔒';

      if (index === 1) {
        ribbon.textContent =
          'BEST VALUE';
      } else if (index === 2) {
        ribbon.textContent =
          'VIP OFFER';
      } else {
        ribbon.textContent =
          'BUY MORE, SAVE MORE';
      }


      const remaining =
        Math.max(
          0,
          minimum - projectedSubtotal
        );

      if (progressText) {
        progressText.textContent =
          'Add ' +
          this.formatMoney(remaining) +
          ' more to unlock';
      }


      const progressPercent =
        minimum > 0
          ? Math.max(
              0,
              Math.min(
                100,
                (
                  projectedSubtotal /
                  minimum
                ) * 100
              )
            )
          : 100;

      if (progressFill) {
        progressFill.style.width =
          progressPercent + '%';
      }

      if (progressMeta) {
        progressMeta.textContent =
          this.formatMoney(
            projectedSubtotal
          ) +
          ' / ' +
          this.formatMoney(
            minimum
          );
      }


      const targetQuantity =
        unitPrice > 0
          ? Math.ceil(
              Math.max(
                0,
                minimum -
                actualSubtotal
              ) / unitPrice
            )
          : quantity;

      card.dataset.targetQuantity =
        String(
          Math.max(
            targetQuantity,
            quantity
          )
        );


      if (helper) {
        helper.textContent = '';
      }

      button.textContent =
        index === 1
          ? 'Shop More'
          : 'Unlock Offer';

      button.dataset.mode =
        'unlock';
    }


    async handleClick(event) {
      const copyTarget =
        event.target.closest(
          '[data-ofy-copy]'
        );

      if (
        copyTarget &&
        this.contains(copyTarget)
      ) {
        const code =
          copyTarget.dataset.code || '';

        await this.copyCode(
          code,
          copyTarget
        );

        return;
      }


      const dot =
        event.target.closest(
          '[data-ofy-dot]'
        );

      if (
        dot &&
        this.contains(dot)
      ) {
        const index =
          Number.parseInt(
            dot.dataset.ofyDot,
            10
          );

        this.scrollToIndex(index);

        return;
      }


      if (
        event.target.closest(
          '[data-ofy-prev]'
        )
      ) {
        this.scrollToIndex(
          this.currentIndex - 1
        );

        return;
      }


      if (
        event.target.closest(
          '[data-ofy-next]'
        )
      ) {
        this.scrollToIndex(
          this.currentIndex + 1
        );

        return;
      }


      const button =
        event.target.closest(
          '[data-ofy-action]'
        );

      if (
        !button ||
        !this.contains(button)
      ) {
        return;
      }

      const card =
        button.closest(
          '[data-ofy-card]'
        );

      if (!card) return;

      const mode =
        button.dataset.mode || '';

      const code =
        button.dataset.code ||
        card.dataset.code ||
        '';


      if (mode === 'copy') {
        await this.copyCode(
          code,
          button
        );

        return;
      }


      if (mode === 'unlock') {
        this.updateQuantityForCard(
          card
        );
      }
    }


    async copyCode(
      code,
      clickedElement
    ) {
      if (!code) return;

      let copied = false;

      try {
        if (
          navigator.clipboard &&
          window.isSecureContext
        ) {
          await navigator.clipboard.writeText(
            code
          );

          copied = true;
        }
      } catch (_) {}


      if (!copied) {
        try {
          const textarea =
            document.createElement(
              'textarea'
            );

          textarea.value = code;

          textarea.setAttribute(
            'readonly',
            ''
          );

          textarea.style.position =
            'fixed';

          textarea.style.opacity =
            '0';

          textarea.style.pointerEvents =
            'none';

          document.body.appendChild(
            textarea
          );

          textarea.select();

          copied =
            document.execCommand(
              'copy'
            );

          textarea.remove();

        } catch (_) {
          copied = false;
        }
      }


      const card =
        clickedElement.closest(
          '[data-ofy-card]'
        );

      if (!card) return;

      const button =
        card.querySelector(
          '[data-ofy-action]'
        );

      const helper =
        card.querySelector(
          '[data-ofy-helper]'
        );

      const copyIcon =
        card.querySelector(
          '[data-ofy-copy-icon]'
        );

      const copyIconButton =
        card.querySelector(
          '[data-ofy-copy]'
        );


      if (copied) {

        if (button) {
          button.textContent =
            '✓ Copied';

          button.classList.add(
            'is-copied'
          );
        }

        if (helper) {
          helper.textContent =
            'Code copied to clipboard!';
        }

        if (copyIcon) {
          copyIcon.textContent = '✓';
        }

        if (copyIconButton) {
          copyIconButton.classList.add(
            'is-copied'
          );
        }

        this.announce(
          code +
          ' copied to clipboard.'
        );


        clearTimeout(
          card._ofyCopyTimer
        );

        card._ofyCopyTimer =
          setTimeout(
            () => {
              if (button) {
                button.classList.remove(
                  'is-copied'
                );
              }

              if (copyIcon) {
                copyIcon.textContent =
                  '▢';
              }

              if (copyIconButton) {
                copyIconButton.classList.remove(
                  'is-copied'
                );
              }

              this.refresh();
            },
            1600
          );

      } else {

        if (helper) {
          helper.textContent =
            'Copy was blocked. Tap and hold the code to copy manually.';
        }

        this.announce(
          'Copy was blocked by the browser.'
        );
      }
    }


    updateQuantityForCard(card) {
      if (!this.quantityInput) {
        this.announce(
          'Increase product quantity to unlock this offer.'
        );

        return;
      }

      let target =
        Number.parseInt(
          card.dataset.targetQuantity,
          10
        );

      const current =
        this.getCurrentQuantity();

      if (
        !Number.isFinite(target) ||
        target <= current
      ) {
        target =
          current + 1;
      }


      const maximum =
        this.quantityInput.max
          ? Number.parseInt(
              this.quantityInput.max,
              10
            )
          : null;

      if (
        Number.isFinite(maximum) &&
        target > maximum
      ) {
        target = maximum;
      }


      this.quantityInput.value =
        String(target);

      this.quantityInput.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );

      this.quantityInput.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );


      card.classList.remove(
        'is-flash'
      );

      void card.offsetWidth;

      card.classList.add(
        'is-flash'
      );


      this.announce(
        'Quantity updated to ' +
        target +
        '.'
      );

      this.refresh();
    }


    scrollToIndex(index) {
      if (!this.cards.length) return;

      const safeIndex =
        Math.max(
          0,
          Math.min(
            index,
            this.cards.length - 1
          )
        );

      const card =
        this.cards[safeIndex];

      if (
        this.track &&
        card
      ) {
        this.track.scrollTo({
          left: card.offsetLeft -
            this.track.offsetLeft,
          behavior: 'smooth'
        });
      }

      this.updateNavigation(
        safeIndex
      );
    }


    handleScroll() {
      clearTimeout(
        this.scrollTimer
      );

      this.scrollTimer =
        setTimeout(
          () => {
            if (
              !this.track ||
              !this.cards.length
            ) {
              return;
            }

            let nearest = 0;
            let smallestDistance =
              Infinity;

            this.cards.forEach(
              (card, index) => {
                const distance =
                  Math.abs(
                    card.offsetLeft -
                    this.track.offsetLeft -
                    this.track.scrollLeft
                  );

                if (
                  distance <
                  smallestDistance
                ) {
                  smallestDistance =
                    distance;

                  nearest =
                    index;
                }
              }
            );

            this.updateNavigation(
              nearest
            );
          },
          80
        );
    }


    updateNavigation(index) {
      this.currentIndex =
        Math.max(
          0,
          Math.min(
            index,
            this.cards.length - 1
          )
        );

      if (this.counter) {
        this.counter.textContent =
          (
            this.currentIndex + 1
          ) +
          ' / ' +
          this.cards.length +
          ' offers';
      }


      if (this.prevButton) {
        this.prevButton.disabled =
          this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled =
          this.currentIndex ===
          this.cards.length - 1;
      }


      this.dots.forEach(
        (dot, dotIndex) => {
          dot.classList.toggle(
            'is-active',
            dotIndex ===
            this.currentIndex
          );
        }
      );
    }


    handleQuantityChange() {
      clearTimeout(
        this.quantityTimer
      );

      this.quantityTimer =
        setTimeout(
          () => this.refresh(),
          100
        );
    }


    handleVariantChange() {
      clearTimeout(
        this.variantTimer
      );

      this.variantTimer =
        setTimeout(
          () => this.refresh(),
          120
        );
    }


    announce(message) {
      if (this.status) {
        this.status.textContent =
          message || '';
      }
    }


    disconnectedCallback() {
      this.removeEventListener(
        'click',
        this.onClick
      );

      if (this.track) {
        this.track.removeEventListener(
          'scroll',
          this.onScroll
        );
      }

      if (this.quantityInput) {
        this.quantityInput.removeEventListener(
          'input',
          this.onQuantityChange
        );

        this.quantityInput.removeEventListener(
          'change',
          this.onQuantityChange
        );
      }

      if (this.form) {
        this.form.removeEventListener(
          'change',
          this.onVariantChange
        );
      }

      clearTimeout(
        this.quantityTimer
      );

      clearTimeout(
        this.variantTimer
      );

      clearTimeout(
        this.scrollTimer
      );

      this.initialized = false;
    }
  }


  customElements.define(
    ELEMENT_NAME,
    ArtTaggedCodeOffers
  );
})();